import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import HelpSectionStyles from '../../styles/HelpSectionStyles';
import Footer from '../Footer';
import italy_trattorial from '../../assets/svg/italy_trattorial.svg';

const HelpSection = () => {
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
        columnSpacing={{ xs: 1, sm: 2, md: 6, lg: 12 }}
        sx={HelpSectionStyles.helpSectionContainer}
        data-testid="help-section-test"
        id="help-section"
      >
        <Grid item xs={12} md={8} lg={6}>
          <Box sx={HelpSectionStyles.image}>
            <img
              src={italy_trattorial}
              id="italy_trattorial"
              alt="Italy Trattorial"
              width="98%"
              data-testid="italy-trattorial-img-test"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={7} lg={5}>
          <Box sx={HelpSectionStyles.helpBox}>
            <Grid container>
              <Grid item xs={6} lg={12}>
                <Typography sx={HelpSectionStyles.helpTitle}>
                  <strong>Need Help?</strong>
                </Typography>
              </Grid>
            </Grid>
            <Box sx={HelpSectionStyles.helpContentBox}>
              <Typography>
                <strong> Custom Solutions </strong>
              </Typography>
              <Typography sx={HelpSectionStyles.helpcontent}>
                Your GroundTruth representative can help you set up a custom
                audience for your postcard mailing, or even integrate it with a
                mobile, desktop or CTV campaign.
              </Typography>
            </Box>
            <Box sx={HelpSectionStyles.helpContentBox}>
              <Typography>
                <strong> Design Instructions </strong>
              </Typography>
              <Typography sx={HelpSectionStyles.helpcontent}>
                You can find design specs{' '}
                <Link
                  target="_blank"
                  href="https://help.groundtruth.com/hc/en-us/articles/11857738444435-Audience-Based-Direct-Mail-Specs"
                  sx={HelpSectionStyles.link}
                >
                  here
                </Link>{' '}
                or use our preset InDesign{' '}
                <Link
                  sx={HelpSectionStyles.link}
                  data-testid="template-link-test"
                  href="./ABDM-template.zip"
                >
                  template
                </Link>{' '}
                to expedite your process.
              </Typography>
            </Box>
            <Typography>
              <strong>GT QR Codes </strong>
            </Typography>
            <Box sx={HelpSectionStyles.helpContentBox}>
              <Typography sx={HelpSectionStyles.helpcontent}>
                Want to track performance? You can add a GT QR Code to measure
                scans, understand scans by location and date, and drive
                additional engagement with your target audience.
              </Typography>
            </Box>
            <Typography sx={HelpSectionStyles.helpcontent}>
              <Link
                href="mailto:hello@groundtruth.com"
                sx={HelpSectionStyles.link}
              >
                hello@groundtruth.com
              </Link>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box sx={HelpSectionStyles.mobileImage}>
            <img
              src={italy_trattorial}
              id="italy_trattorial"
              alt="Italy Trattorial"
              width="100%"
              data-testid="italy-trattorial-mobile-img-test"
            />
          </Box>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default HelpSection;
